
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Project } from '@shared/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { HintComponent } from "@shared-angular/components/hint/hint.component";
import { LoginService } from '@shared-angular/services/login.service';
import { ProjectService } from '../../../../../../shared/services/project.service';
import { ToastrService } from '@shared-angular/services/toastr.service';

@Component({
  imports: [FormsModule, HintComponent, InputText, TextareaModule, SelectModule, ButtonModule],
  templateUrl: './edit-project-modal.component.html',
  styleUrl: './edit-project-modal.component.scss'
})
export class EditProjectModalComponent implements OnInit {

  public project!: Project;
  public name!: string;
  public description!: string;
  public editMode!: "none" | "creator" | "everyone";
  public orgShort!: string;

  public editModeOptions = [
    { label: $localize`:@@only-creator:Ersteller`, value: 'creator' },
    { label: $localize`:@@everyone:Jedem in der Organisation`, value: 'everyone' },
    { label: $localize`:@@no-editing:Niemanden`, value: 'none' }
  ];

  public get orgShareOptions(): { label: string; value: string }[] {
    return [
      { label: $localize`:@@no-sharing:Nicht geteilt`, value: '' },
      ...this.loginService.myOrgs.map((model) => ({ label: model.name, value: model.short }))
    ];
  }

  constructor(
    public projectService: ProjectService,
    public loginService: LoginService,
    private bsModalRef: BsModalRef,
    private toastr: ToastrService
  ) { }


  public ngOnInit(): void {
    this.name = this.project.name;
    this.description = this.project.description;
    this.editMode = this.project.editMode;
    this.orgShort = this.project.orgShort;
  }

  public canChange(project: Project) {
    return this.editMode == 'creator' && project.creator == this.loginService.loggedInUser?._id || this.editMode == 'everyone';
  }


  public async updateProject() {
    await this.projectService.updateProject({
      ...this.project,
      name: this.name.trim(),
      description: this.description.trim(),
      editMode: this.editMode,
      orgShort: this.orgShort
    });
    this.toastr.success('SAVED');
    this.bsModalRef.hide();
  }

}
